import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as initActions from '../actions/initActions';
import * as trackingDataActions from '../actions/trackingDataActions';
import * as userDataActions from '../actions/userDataActions';
import * as appDataActions from '../actions/appDataActions';
import * as resourceActions from '../actions/resourcesActions';
import * as objectConstants from '../constants/objectConstants';
import * as appConstants from '../constants/appConstants';
import {RESOURCE_PROPS} from '../models/appModels';
import Footer from './AppFooter';
import * as actionTypes from '../actions/actionTypes';
import * as appHelper from '../helpers/appHelper';
import * as dataHelper from '../helpers/dataHelper';
import * as localStorageObj from '../localStorage/localStorage';
import * as keyboardConstants from '../constants/keyboardConstants';

class App extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            showFooter: false,
            lesson_location: this.props.lesson_location,
            tracking_type: this.props.tracking_type,
            activeResourcesId: this.props.activeResourcesId,
            audio: this.props.audio,
            fontSize: this.props.fontSize,
            showResources: false,
            checkForUpdate: false,
            bookmark: 0,
            audioFiles: [],
            dataReady: false,
            audioLoaded: false,
            checkPlayAudio: false,
            audioIsPlaying: false,
            audioQue: [],
            trackingData: props.trackingData,
            currentAudioId: props.currentAudioId,
            pauseIfPlaying: false
        };

        this.redirect = this.redirect.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.setFooter = this.setFooter.bind(this);
        this.footerTextExists = this.footerTextExists.bind(this);
        this.onMessage = this.onMessage.bind(this);
        this.setScreenId = this.setScreenId.bind(this);
        this.openResources = this.openResources.bind(this);
        this.goToBite = this.goToBite.bind(this);
        this.getAudioFiles = this.getAudioFiles.bind(this);
        this.getAssetPath = this.getAssetPath.bind(this);
        this.readyAudio = this.readyAudio.bind(this);
        this.checkAudio = this.checkAudio.bind(this);
        this.playAudioRef = this.playAudioRef.bind(this);
        this.pauseAudioRef = this.pauseAudioRef.bind(this);
        this.skipToMainContent = this.skipToMainContent.bind(this);
        this.onSetLanguage = this.onSetLanguage.bind(this);
        this.setShowOutline = this.setShowOutline.bind(this);
        this.setInstructor = this.setInstructor.bind(this);
        this.clearAudiQue = this.clearAudiQue.bind(this);
    }

    componentDidMount() {
        let app = document.getElementById("app");
        app.style.fontSize = `${this.state.fontSize.currentFontSize}%`;
        let isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
        let eventName = isOnIOS ? "pagehide" : "beforeunload";
        window.addEventListener(eventName, this.onUnload);
        window.addEventListener("message", this.onMessage, false);

        let path = '/';
        this.redirect(path);
    }

    componentWillReceiveProps(nextProps) {
        if (appHelper.isDefined(this.props.contentData.experience) && !this.state.showFooter) {
            this.setFooter();
        }

        if (this.state.tracking_type !== nextProps.tracking_type) {
            this.setState({tracking_type: nextProps.tracking_type});
        }

        if (this.state.lesson_location !== nextProps.lesson_location && !isNaN(nextProps.lesson_location) && this.state.tracking_type === appConstants.TRACKING_TYPE_OPEN) {
            this.setState({lesson_location: nextProps.lesson_location});
            try {
                //console.log(`app postMessage setScreenId ${nextProps.lesson_location}`);
                window.parent.postMessage({
                    'func': 'setScreenId',
                    'message': nextProps.lesson_location
                }, "*");
            } catch (error) {
                //console.log(`app postMessage setScreenId error ${nextProps.lesson_location}`, error);
            }
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({lang: nextProps.lang});
            try {
                //console.log(`app onSetLanguage setScreenId ${nextProps.lang}`);
                window.parent.postMessage({
                    'func': 'onSetLanguage',
                    'message': nextProps.lang
                }, "*");
            } catch (error) {
                //console.log(`app postMessage onSetLanguage error ${nextProps.lang}`, error);
            }
        }

        if (this.state.activeResourcesId !== nextProps.activeResourcesId) {
            this.setState({activeResourcesId: nextProps.activeResourcesId, showResources: true});
        }

        if (!this.state.dataReady && appHelper.isDefined(this.props.contentData.experience) && appHelper.isDefined(this.props.contentData.experience.experience_id)) {
            this.getAudioFiles();
        }

        if (this.state.audio.audioRef !== nextProps.audio.audioRef) {
            if (nextProps.audio.audioRef.length > 0) {
                if (appHelper.getArrayObjectIndexByKey(this.state.audioQue, "audioRef", nextProps.audio.audioRef) === -1) {
                    this.setState({
                        audio: Object.assign({}, nextProps.audio),
                        audioQue: dataHelper.immutablePush(this.state.audioQue, nextProps.audio),
                    });
                }
            } else {
                this.pauseAudioRef(this.state.audioQue[0]);
                let audioQue = dataHelper.immutableSplice(this.state.audioQue, 0, this.state.audioQue.length);
                this.setState({
                    audio: Object.assign({}, nextProps.audio),
                    audioQue: audioQue,
                    audioIsPlaying: false
                });
            }
        }
        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize});
            let app = document.getElementById("app");
            app.style.fontSize = `${nextProps.fontSize.currentFontSize}%`;
        }

        if (this.state.trackingData !== nextProps.trackingData) {
            this.setState({
                trackingData: nextProps.trackingData,
            });
        }

        if (this.state.currentAudioId !== nextProps.currentAudioId && appHelper.isDefined(nextProps.currentAudioId)) {
            this.setState({
                currentAudioId: nextProps.currentAudioId,
                pauseIfPlaying: this.state.audioIsPlaying && nextProps.currentAudioId !== this.state.audioQue[0].audioRef
            });
        }

    }

    componentDidUpdate() {
        if (this.state.showResources) {
            this.openResources();
        }

        if (this.state.checkForUpdate && this.state.bookmark !== 0) {
            this.goToBite();
        }

        if (this.state.audioFiles.length > 0 && !this.state.audioLoaded) {
            this.readyAudio();
        }

        if (!this.state.audioIsPlaying && this.state.audioQue.length > 0) {
            this.playAudioRef();
        }

        if (this.state.pauseIfPlaying) {
            this.clearAudiQue();
        }

    }

    componentWillUnmount(){

        //console.log(`app componentWillUnmount`);
        let isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
        let eventName = isOnIOS ? "pagehide" : "beforeunload";
        window.removeEventListener(eventName, this.onUnload);
        //console.log(`app message`);
        window.removeEventListener("message", this.onMessage, false);

    }

    getAudioFiles() {

        let audioFiles = appHelper.getAudioToPreload(this.props.contentData.experience.assets);
        this.setState({
            dataReady: true,
            audioFiles: Object.assign([], audioFiles)
        });
    }

    onMessage(e) {

        if (appHelper.isDefined(e) && appHelper.isDefined(e.data)) {
            ////console.log(`onMessage`, e);
            const data = e.data;
            //console.log(`onMessage data`, data);
            //console.log('onMessage: data',data);
            if (typeof this[data.func] !== 'undefined') {
                //console.log(`onMessage data`, data);
                try {
                    this[data.func](data.message);
                } catch (error) {
                    //console.log(`onMessage catch error`, error);
                }
            }
        }
    }

    onSetLanguage(message) {
        //console.log(`onSetLanguage`, message);
        try {
            if (appHelper.isDefined(message)) {
                this.props.actions.updateExperienceLocale(message.language_code);
            }
        } catch (error) {
            //console.log(`onSetLanguage catch error`, error);
        }
    }


    setShowOutline(message) {
        //console.log(`setShowOutline`, message);
        try {
            if (appHelper.isDefined(message)) {
                this.props.actions.showContentOutline(message.showContentOutlineInPreview);
            }
        } catch (error) {
            //console.log(`setShowOutline catch error`, error);
        }
    }

    setScreenId(message) {
        try {
            if (appHelper.isDefined(message)) {
                if (appHelper.isDefined(message.screen_type) && appHelper.isDefined(message.screen_id)) {
                    if (message.screen_type === objectConstants.TYPE_MENU && message.screen_id === -1) {
                        this.context.router.push(`/menu`);
                    } else if (message.screen_type === objectConstants.TYPE_RESOURCE) {
                        let resourceProps = Object.assign({}, RESOURCE_PROPS, {
                            activeResourcesId: message.screen_id,
                            sourceId: ""
                        });
                        this.props.actions.setResourcesProps(resourceProps);
                    } else if (message.screen_type === objectConstants.TYPE_SCREEN) {
                        let bookmark = appHelper.getBiteByScreenId(message.screen_id);
                        this.props.actions.setNewLessonLocation(message.screen_id);
                        this.context.router.push(`/${bookmark}`);
                    }
                }
            }
        } catch (error) {
            //console.log(`setScreenId catch error`, error);
        }
    }

    setInstructor(message) {
        //console.log(`setInstructor`, message);
        //console.log(`setInstructor`,message.instructor);
        try {
            if (appHelper.isDefined(message)) {
                this.props.actions.setInstructor(message.instructor);
            }
        }catch(error){
            //console.log(`setInstructor catch error`, error);
        }

    }

    goToBite() {
        this.setState({checkForUpdate: false});
        this.context.router.push(this.state.bookmark);
    }


    footerTextExists() {
        if (appHelper.isDefined(this.props.contentData.experience)) {
            let locale = appHelper.getLocalData(this.props.contentData.experience);
            return appHelper.isDefined(locale.footer_text) && locale.footer_text.length > 0;
        } else {
            return false;
        }

    }

    setFooter() {
        this.setState({showFooter: this.footerTextExists()});
    }

    redirect(path) {
        this.context.router.push(path);
    }

    onUnload(event) {
        //console.log(`onUnload doQuickLMSCommit`);
        this.props.actions.doQuickLMSCommit(this.props.contentData.experience.tracking_type);
        //console.log(`onUnload doQuickLMSFinish`);
        this.props.actions.doQuickLMSFinish(this.props.contentData.experience.tracking_type);
        //console.log(`onUnload - done`);
        event.returnValue = "";

    }

    openResources() {
        this.setState({showResources: false});
        if (this.state.activeResourcesId !== 0 && this.props.displayResources === actionTypes.STATUS_CLOSED) {
            // this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPENING);
        }
    }

    playAudioRef() {
        let audioRef = this.refs[`${this.state.audioQue[0].audioRef}`];
        if (appHelper.isDefined(audioRef) && audioRef !== null) {
            try {
                audioRef.currentTime = 0;
            } catch (err) {
                //console.log(`audio currentTime error`, err);
            }
            audioRef.play();

            audioRef.onplay = function () {
                this.props.actions.setCurrentAudio(this.state.audioQue[0].audioRef);
                this.setState({audioIsPlaying: true});
            }.bind(this);

            audioRef.onended = function () {
                let audioQue = dataHelper.immutableSplice(this.state.audioQue, 0, 1);
                this.setState({
                    audioQue: Object.assign([], audioQue),
                    audioIsPlaying: false,
                });
            }.bind(this);
        }
    }

    pauseAudioRef(audio) {
        if (appHelper.isDefined(audio)) {
            let audioRef = this.refs[`${audio.audioRef}`];
            if (appHelper.isDefined(audioRef)) {
                audioRef.pause();
            }
        }
    }

    clearAudiQue(audio) {
        //if(appHelper.isDefined(audio)) {
        let audioRef = this.refs[`${this.state.audioQue[0].audioRef}`];
        if (appHelper.isDefined(audioRef)  && audioRef !== null) {
            audioRef.pause();
            this.setState({
                audioIsPlaying: false,
                audioQue: Object.assign([], []),
                pauseIfPlaying: false
            });
        }
        //}
    }

    getAssetPath(asset) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(asset) && asset.length > 0) {
                return require(`../../moveToDist/${asset}`);
            }
        } else {
            return asset;
        }
    }

    checkAudio() {
        //this.readyAudio();
    }


    readyAudio() {

        this.setState({audioLoaded: true});
        for (let i = 0; i < this.state.audioFiles.length; i++) {

            let audio = this.state.audioFiles[i];
            let audioRef = this.refs[`audio_${audio.id}_${audio.type}`];
            // console.log(audioRef);
            if(appHelper.isDefined(audioRef) && audioRef !== null) {
                try{
                    audioRef.load();
                }catch(err){
                    //console.log(`audio load error`, err);
                }
                //

                try {
                    audioRef.currentTime = 0;
                } catch (err) {
                    //console.log(`audio currentTime error`, err);
                }

                try {
                    audioRef.pause();
                } catch (err) {
                    //console.log(`audio pause error`, err);
                }

                /* audioRef.pause();*/
            }

        }
    }

    skipToMainContent(event) {
        let targetEl = document.getElementById("appScreen");
        targetEl.focus();
    }

    render() {
        return (
            <div className="main-content-wrapper">
                <button id="skipToMainContent" className="hidden-el" tabIndex="0" onClick={this.skipToMainContent}
                        onKeyDown={this.skipToMainContent}>Skip to main content
                </button>
                <div className="main" id="main-wrapper">
                    <div className="content-body">
                        {this.props.children}
                    </div>
                </div>
                {
                    this.state.showFooter
                        ?
                        <Footer/>
                        :
                        null
                }

                {this.state.audioFiles.length > 0
                    ? this.state.audioFiles.map(audio =>
                        appHelper.isDefined(audio.locale[this.state.lang])
                            ?
                            <audio key={`audio_${audio.id}_${audio.type}`} ref={`audio_${audio.id}_${audio.type}`}
                                   src={this.getAssetPath(audio.locale[this.state.lang].src)} preload="auto"/>
                                   :
                            null
                    )
                    : null
                }

            </div>
        );
    }
}

App.propTypes = {
    children: PropTypes.object.isRequired,
    navigation: PropTypes.object,
    actions: PropTypes.object.isRequired,
    dialogPopup: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    displayMainMenu: PropTypes.string.isRequired,
    displayResources: PropTypes.string.isRequired,
    lesson_location: PropTypes.number.isRequired,
    tracking_type: PropTypes.string.isRequired,
    activeResourcesId: PropTypes.number.isRequired,
    audio: PropTypes.object.isRequired,
    fontSize: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    trackingData: PropTypes.object.isRequired,
    currentAudioId: PropTypes.string.isRequired,
};

App.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lesson_location = 0;
    let tracking_type = "";

    if (appHelper.isDefined(state.trackingData)) {
        lesson_location = state.trackingData.lesson_location;
    }

    if (appHelper.isDefined(state.contentData.experience)) {
        tracking_type = state.contentData.experience.tracking_type;
    }
    return {
        navigation: state.navigation,
        dialogPopup: state.dialogPopup,
        contentData: state.contentData,
        displayMainMenu: state.displayMainMenu,
        displayResources: state.displayResources,
        lesson_location: parseInt(lesson_location),
        tracking_type: tracking_type,
        activeResourcesId: state.resourceProps.activeResourcesId,
        audio: state.audio,
        fontSize: state.fontSize,
        lang: appHelper.isDefined(state.userData.lang) ? state.userData.lang : "",
        trackingData: state.trackingData,
        currentAudioId: state.currentAudioId

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions, resourceActions, userDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/